<p>
  The resources you have configured {{ uiService.productName }} to protect exceed your licensed resource count.
  Replication from this primary environment to this recovery environment is currently blocked. To address this
  situation, unselect some replicated resources, or contact Arpio to have your subscription upgraded.
</p>
<p>You can review your current and licensed resource counts <a [routerLink]="accountSettingsUrl">here</a>.</p>
